module.exports = {"name":"Delegované hlasy používateľa","icon":"<i class='material-icons'>swap_horizontal_circle</i>","widget":{"type":"voting-delegated-votes-user","initData":{},"schemas":{"votes":"urn:mbry:schema:1:votes-delegation:v1"}}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/voting-delegated-votes-user/voting-delegated-votes-user.json
// module id = 405
// module chunks = 0